import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { House, ChartBar, Calendar, TrendUp, DotsThreeOutline, Users, CheckCircle, Bell, Coins, UserCircle } from "@phosphor-icons/react";

export default function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  if (!user) return null;

  const getTabsForRole = () => {
    const effectiveRole = (user.role === "administrator" && (user.active_view === "preview_employee" || user.active_view === "self_employee")) 
      ? "employee" 
      : user.role;

    if (effectiveRole === "employee") {
      return [
        { id: "home", label: "Home", path: "/", icon: House },
        { id: "earnings", label: "Earnings", path: "/earnings", icon: Coins },
        { id: "timeoff", label: "Time Off", path: "/pto", icon: Calendar },
        { id: "career", label: "Career", path: "/career", icon: TrendUp },
        { id: "more", label: "More", path: "/more", icon: DotsThreeOutline },
      ];
    } else if (effectiveRole === "manager") {
      return [
        { id: "home", label: "Home", path: "/", icon: House },
        { id: "team", label: "Team", path: "/manager/team", icon: Users },
        { id: "approvals", label: "Approvals", path: "/manager/approvals", icon: CheckCircle },
        { id: "announcements", label: "Announce", path: "/admin/announcements", icon: Bell },
        { id: "more", label: "More", path: "/more", icon: DotsThreeOutline },
      ];
    } else if (effectiveRole === "administrator") {
      return [
        { id: "home", label: "Home", path: "/", icon: House },
        { id: "team", label: "Team", path: "/admin/team", icon: Users },
        { id: "payroll", label: "Payroll", path: "/admin/payroll", icon: ChartBar },
        { id: "announcements", label: "Announce", path: "/admin/announcements", icon: Bell },
        { id: "more", label: "More", path: "/more", icon: DotsThreeOutline },
      ];
    }
    return [];
  };

  const tabs = getTabsForRole();
  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex items-center justify-around h-16 max-w-screen-xl mx-auto">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = isActive(tab.path);
          
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center w-full h-full min-w-[44px] transition-colors ${
                active
                  ? "text-[hsl(var(--bronze))]"
                  : "text-muted-foreground hover:text-foreground"
              }`}
              style={{ WebkitTapHighlightColor: "transparent" }}
            >
              <Icon size={24} weight={active ? "fill" : "regular"} />
              <span className={`text-xs mt-1 ${active ? "font-semibold" : "font-normal"}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
